import { Reveal } from "./shared";

const CHAPTERS = [
  {
    n: "01",
    span: "lg:col-span-6",
    title: "Why the Score Is a Receipt",
    tagline: "The Account Health Rating is a lagging historical record, not a forward shield.",
    body: "Understand how Amazon's internal algorithms evaluate accounts across lifecycle, velocity, and metric elasticity — and why a pristine 200 rating gives high-volume sellers a dangerous false sense of security right before account reviews.",
  },
  {
    n: "02",
    span: "lg:col-span-6",
    title: "The Dumbest Reasons Accounts Die",
    tagline: "Forensic post-mortems of real suspensions caused by trivial blind spots.",
    body: "Innocent operational glitches — a thrown-out verification postcard, 'pain relief' printed on a cushion, unlinked return dispositions, supplier invoices missing minor tax details — that trigger catastrophic automated holds.",
  },
  {
    n: "03",
    span: "lg:col-span-7",
    title: "Live Account Split Screen",
    tagline: "Real Seller Central logs juxtaposed with live API signal tracking.",
    body: "Watch a live side-by-side demonstration comparing what Amazon shows the seller versus the 50 underlying behavioral signals — ODR trends, NCX clusters, cancellation velocity — running behind the scenes on the same account, the same day.",
  },
  {
    n: "04",
    span: "lg:col-span-5",
    title: "What a Suspension Actually Costs",
    tagline: "Beyond lost daily GMV: the compounding balance-sheet destruction.",
    body: "Stranded inventory aging fees, PPC ranking collapse, lost Buy Box history, frozen working capital — the whole number, on paper.",
  },
];

export const Chapters = () => (
  <section data-testid="chapters-section" className="py-20 lg:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-indigo-700">
          The curriculum
        </p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-900 mt-4 max-w-2xl">
          Four chapters. One session. Zero fluff.
        </h2>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-5">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.07} className={c.span}>
            <article
              data-testid={`chapter-${c.n}`}
              className="h-full bg-white rounded-2xl border border-slate-200 p-8 transition-all duration-300 hover:border-indigo-200 hover:shadow-lg hover:shadow-indigo-100/60"
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-sm font-bold text-indigo-600 bg-indigo-50 border border-indigo-100 rounded-md px-2.5 py-1">
                  {c.n}
                </span>
                <span className="font-mono text-[10px] uppercase tracking-widest text-slate-400 mt-1.5">
                  Chapter
                </span>
              </div>
              <h3 className="font-display font-bold tracking-tight text-2xl text-slate-900 mt-5">{c.title}</h3>
              <p className="text-sm font-semibold text-indigo-700 mt-2">{c.tagline}</p>
              <p className="text-sm text-slate-600 leading-relaxed mt-3">{c.body}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
